export enum CreateOnlineWebinarStepsIndex {
  detailsStep = 0,
  communicationStep = 1,
  sessionStep = 2,
}
